
import { authTokenStorage, enterpriseIdStorage, sessionIdStorage } from "./StorageHelper";
import DateTimeHelper from "./DateTimeHelper";

const Create = (event: React.FormEvent<HTMLFormElement> | undefined, showLoading?: boolean) => {
    let formData = new FormData(event?.currentTarget);

    formData = Add(formData, 'sessionId', sessionIdStorage.get());
    formData = Add(formData, 'datetime', DateTimeHelper.Now('YYYY-MM-DD HH:mm:ss'));

    showLoading = showLoading !== undefined ? showLoading : true;
    formData = Add(formData, 'showLoading', showLoading.toString());

    const storedAuthToken = authTokenStorage.get();
    if (storedAuthToken) {
        formData = Add(formData, 'authToken', storedAuthToken);
    }

    const storedEnterpriseId = enterpriseIdStorage.get();
    if (storedEnterpriseId) {
        formData = Add(formData, 'enterpriseId', storedEnterpriseId);
    }

    return formData;
}


const Add = (formData: FormData, key: string, value: string | number | Blob | undefined | File) => {
    if (value === undefined) {
        return formData;
    }
    
    if (formData.has(key)) {
        formData.delete(key);
    }

    if (typeof value === 'number') {
        value = value.toString();
    }

    formData.append(key, value);
    return formData;
}



const FormHelper = {
    Create,
    Add
}

export default FormHelper;